  <div class="row">
    <div class="col-12">
          <!-- 🟧 Crypto Card -->
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-12 col-md-6"><i class="fa-fw fas fa-coins me-2"></i>Crypto Ticker</div>
                <div class="col-12 col-md-6 text-end">
                  <div class="btc-refresh" *ngIf="lastRefresh">
                    Last Update {{ lastRefresh | date:'mediumTime' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 normal">
                  <table class="table table-condensed" *ngIf="!isLoading; else loadingTemplate">
                    <thead>
                      <tr class="text-center">
                        <th>Coin</th>
                        <th>Price</th>
                        <th>24h Change</th>
                        <th>1h Change</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="pointer" (click)="toggleGraph('BTC')">
                        <td><span><i class="fa-brands fa-fw fa-bitcoin me-2"></i>Bitcoin</span></td>
                        <td style="width:110px" class="text-end"><span class="btc-price">${{ btcPrice | number: '1.2-2' }}</span></td>
                        <td [ngClass]="(btcChange! >= 0) ? 'positive' : 'negative'" style="width:110px" class="text-end"><span>{{ btcChange | number: '1.2-2' }}%</span></td>
                        <td [ngClass]="(btcChange1h! >= 0) ? 'positive' : 'negative'" style="width:110px" class="text-end"><span>{{ btcChange1h | number: '1.2-2' }}%</span></td>
                      </tr>
                      <tr class="pointer" (click)="toggleGraph('ETH')">
                        <td><span><i class="fa-brands fa-fw fa-ethereum me-2"></i>Ethereum</span></td>
                        <td class="text-end"><span class="btc-price">${{ ethPrice | number: '1.2-2' }}</span></td>
                        <td [ngClass]="(ethChange! >= 0) ? 'positive' : 'negative'" class="text-end"><span>{{ ethChange | number: '1.2-2' }}%</span></td>
                        <td [ngClass]="(ethChange1h! >= 0) ? 'positive' : 'negative'" class="text-end"><span>{{ ethChange1h | number: '1.2-2' }}%</span></td>
                      </tr>
                      <tr class="pointer" (click)="toggleGraph('SOL')">
                        <td><span><i class="fas fa-fw fa-coins me-2"></i>Solana</span></td>
                        <td class="text-end"><span class="btc-price">${{ solPrice | number: '1.2-2' }}</span></td>
                        <td [ngClass]="(solChange! >= 0) ? 'positive' : 'negative'" class="text-end"><span>{{ solChange | number: '1.2-2' }}%</span></td>
                        <td [ngClass]="(solChange1h! >= 0) ? 'positive' : 'negative'" class="text-end"><span>{{ solChange1h | number: '1.2-2' }}%</span></td>
                      </tr>
                    </tbody>
                  </table>

                  <ng-template #loadingTemplate>
                    <div class="btc-row">
                      <div class="btc-card loading">
                        <div class="spinner"></div>
                        <p>Fetching Crypto Prices...</p>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="text-center normal"><strong>{{graphLabel}}</strong></div>
                  <div style="height:25vh;">
                    <canvas
                            baseChart
                            [type]="lineChartType"
                            [data]="lineChartData"
                            [options]="lineChartOptions"
                            style="width:100%;margin:auto"
                            >
                    </canvas>
                  </div>
                </div>
              </div>
            <div>
          </div>
        </div>
      </div>
    </div>
  </div>


